define('../common/blocks/tariff/tariff',[],function() {
    (function() {
        function addListeners($tariff) {
            var $switch = $tariff.find('.tariff__switch');

            $switch.off('click', '.tariff__switch__option');
            $switch.on('click', '.tariff__switch__option', function() {
                var $option = $(this);
                var href = $option.data('href');
                var value = $option.data('value');
                var allValues = $option.parent().find('[data-value]').get().map(function(item) {return $(item).data('value')});
                var $tariff = $option.closest('.tariff');
                var $button = $tariff.find('.tariff__button');

                var $carousel = $tariff.closest('.owl-carousel');
                if ($carousel) {
                    var lable = $button.data('label');
                    $tariff = $carousel.find('[data-label=' + lable + ']').closest('.tariff');
                    $button = $tariff.find('.tariff__button');
                }

                $tariff.removeClass(allValues).addClass(value);
                $button.attr('href', href);
            });

            $tariff.off('click', '.disko');
            $tariff.on('click', '.disko', function(event) {
                event.stopPropagation();
                event.preventDefault();
                window.open('https://disk-o.cloud/', '_blank');
            });
        }

        var $carousel = $('.owl-carousel');
        if ($carousel) {
            $carousel.on('refreshed.owl.carousel', function() {
                console.log($(this, '.tariff'));
                addListeners($(this, '.tariff'));
            })
        }
        addListeners($('.tariff'));
    })();
});

